import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logo from "../assets/loginImage.jpeg";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from '@mui/material/IconButton';

const LoginPage = styled.div`
  display: flex;
  height: 100vh;
  background-color: #fff;
`;

const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F5C000;
`;

const RightContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #FFF;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;
`;

const LoginForm = styled.form`
  max-width: 300px;
  width: 100%;
  position: relative; /* Ensure proper positioning for the eye icon */
`;

const InputField = styled.input`
  width: 100%;
  padding: 12px 40px 12px 12px; /* Adjust padding to accommodate the icon */
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 15px;
  background-color: #F5C000;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #F5C000;
  }
`;

const AppLink = styled.a`
  color: #e74c3c;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  height: 20px;

  &:hover {
    text-decoration: underline;
  }
`;

const RightContent = styled.div`
  text-align: center;
`;

const AdminHeading = styled.h3`
  font-size: 24px;
  margin-bottom: 10px;
`;

const AccountDescription = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
`;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if email or password is empty
    if (!email) {
      toast.error("Email is required");
      return;
    }

    if (!password) {
      toast.error("Password is required");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Invalid email address");
      return;
    }

    try {
      const response = await axios.post(
        "/authenticate/admin",
        { email, password }
      );

      if (response.data.status === 401) {
        //console.log"Unauthorized User");
        toast.error("Please enter a valid email or password.");
        return;
      }
      
      if (response.data.status === 200) {
        const token = response?.data?.response?.jwt;
        localStorage.setItem("token", token);
        navigate("/user-management");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred. Please try again later.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <LoginPage>
      <LeftContainer>
        <Logo src={logo} alt="Company Logo" />
      </LeftContainer>
      <RightContainer>
        <ToastContainer />
        <RightContent>
          <AdminHeading>Admin</AdminHeading>
          <AccountDescription>Login to your account</AccountDescription>
          <LoginForm onSubmit={handleSubmit}>
            <InputField
              type="text"
              placeholder="Email ID"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <InputField
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <IconContainer>
              <IconButton onClick={togglePasswordVisibility}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </IconContainer>
            <LoginButton type="submit">Login Now</LoginButton>
          </LoginForm>
        </RightContent>
      </RightContainer>
    </LoginPage>
  );
};

export default Login;
